

import React, { memo } from 'react';

import Button from '../../../Button';
import ToolTip from '../../../ToolTip';
import '../../styles/_modal-footer.scss';































/**
 * Will not render the footer save button if no onSave function is passed as a prop
 * @param {*} props
 *
 * @return { React.Element }
 */
const SaveButton = (props) => {
  const {
    onSave,
    saving,
    saveDisabled,
    saveText,
    saveBtnType,
    saveButtonId
  } = props;

  if (!onSave) {return null;}

  return (
    <Button
      id={saveButtonId || saveText}
      className="modal__save-button"
      busy={saving}
      onClick={onSave}
      disabled={saveDisabled}
      type={saveBtnType || 'PRIMARY'}>

      {saveText}
    </Button>);

};

/**
 * A modal footer component.
 *
 * @return {React.Element}
 */
function ModalFooter(
{
  footerChildren,
  saveText,
  closeText = 'Cancel',
  closeBtnType = 'TERTIARY',
  onClose,
  onSave,
  saving,
  saveDisabled,
  handlePrint,
  printText = 'Download',
  showPrintBtn = false,
  showCancelBtn = true,
  title,
  saveBtnType,
  showExtraButtons = false,
  footerExtraButtons,
  saveButtonId,
  printBtnType
})
{
  return (
    <div className="modal__footer">
      <div className="modal__footer__children">
        {footerChildren}
      </div>

      <div className="modal__footer__controls">
        {showCancelBtn && <Button onClick={onClose} type={closeBtnType}>{closeText}</Button>}
        {showExtraButtons && footerExtraButtons && footerExtraButtons}
        <ToolTip id={saveDisabled && title === 'Confirm Project Submission' ? 'low-credit' : ''} label="There are no credits available to submit this video">
          <div>
            <SaveButton
              saveButtonId={saveButtonId}
              onSave={onSave}
              saving={saving}
              saveDisabled={saveDisabled}
              saveText={saveText}
              saveBtnType={saveBtnType} />

          </div>
        </ToolTip>
        {showPrintBtn && <Button onClick={handlePrint} type={printBtnType}>{printText}</Button>}
      </div>
    </div>);

}

ModalFooter.defaultProps = {
  saveDropdownToggle: false
};

export default memo(ModalFooter);